import * as universes from '@front/common/src/ducks/common/universes';
import * as proAccounts from '@front/common/src/ducks/customer/pro-accounts';
import * as basket from '@front/common/src/ducks/customer/basket';

export default {
  universes,
  proAccounts,
  basket,
};
